import { CERTIFICATIONS } from "../lib/content";
import { ShieldCheck, Globe2, BadgeCheck, Truck } from "lucide-react";
import { motion } from "framer-motion";

const iconMap = { ShieldCheck, Globe2, BadgeCheck, Truck };

export default function Certifications() {
  return (
    <section className="py-24 sm:py-32 bg-[#F4F5F8]" data-testid="certifications-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-[#F37021]" />
              <span className="text-eyebrow text-[#F37021]">Standards</span>
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.02] text-[#0A1F3F]">
              Certifications
              <br />
              &amp; Compliance
            </h2>
            <p className="mt-6 text-base sm:text-lg text-[#4B5668] leading-relaxed max-w-lg">
              BNM Group follows international trade standards and works with
              certified suppliers and logistics partners to ensure quality,
              reliability, and compliance with global regulations.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {CERTIFICATIONS.map((c, i) => {
              const Icon = iconMap[c.icon];
              return (
                <motion.div
                  key={c.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="bg-white border border-[#E3E6EC] p-8 hover-lift"
                  data-testid={`cert-card-${i}`}
                >
                  <div className="w-11 h-11 bg-[#0A1F3F] text-white flex items-center justify-center mb-5">
                    {Icon && <Icon className="w-5 h-5" />}
                  </div>
                  <h3 className="font-display font-bold text-xl tracking-tight text-[#0A1F3F]">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#4B5668] leading-relaxed">{c.body}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
